import React from 'react';
import './ProductFeatures.css';
import siteConfig from '../../configuration/siteConfiguration';

const FeatureIcon = ({ icon }) => (
  <div className="feature-icon-wrapper">
    <img src={`${siteConfig.assetBaseUrl}/icons/cognitva-cip/smart-product-features/${icon}`} alt="Feature Icon" className="feature-svg" />
  </div>
);

const productFeaturesData = [
  {
    title: 'Modular, domain-agnostic AI platform',
    description: 'Cognitva WEAVE™ delivers reusable, plug-and-play AI blocks that adapt seamlessly to any industry - Legal, Healthcare, Financial Services, ESG & Energy, and more. Build once, launch everywhere, and reduce development costs by over 60%.',
    icon: 'modular-domain-agnostic-ai-platform.svg',

  },
  {
    title: '80% Reusable Core Cross-Industry',
    description: 'Launch intelligent solutions across Legal, Health, FinTech, ESG & Energy, and more - all on a single AI backbone that adapts to your domain without starting from scratch.',
    icon: '80_-reusable-core.svg',
  },
  {
    title: 'Domain Intelligence Layer',
    description: 'Cognitva’s Domain Intelligence Layer infuses industry-specific taxonomies, legal/medical/financial ontologies, and fine-tuned LLMs into every AI interaction. That means fewer hallucinations, smarter automation, and results grounded in your real-world context.',
    icon: 'domain-intelligence-layer.svg',
  },
  {
    title: 'Multi-Agent Framework',
    description: 'Accelerate complex workflows with AI teams that collaborate like humans. Organizations can deploy specialized AI copilots (e.g., Legal Drafting, Compliance Checker, Risk Scorer) that work in sync, drastically reducing manual handoffs, eliminating silos, and enabling intelligent decisions at speed and scale.',
    icon: 'multi-agent-framework.svg',
  },
  {
    title: 'Scalable Microservices Stack',
    description: 'Cognitva’s microservices-based architecture ensures enterprise-grade performance with high availability, horizontal scalability, and modular upgrades. Whether you\'re powering 100 users or 100,000, your AI ecosystem stays responsive, resilient, and future- ready.',
    icon: 'scalable-microservices-stack.svg',
  },
  {
    title: 'Security & Trust Layer',
    description: 'Cognitva WEAVE™ embeds security into every layer, with zero-trust architecture, full encryption, access-controlled copilots, and audit-ready logs. This ensures your data, decisions, and documents are protected - always.',
    icon: 'security--trust-layer.svg',
  },
];

const ProductFeatures = () => {
  return (
    <section className="product-features-section">
      <div className="wave1-bg">
        <img src="/images/wavedownward.svg" alt="" />
      </div>
      <div className="product-features-container">
        <p className="product-features-tagline">- Why It Matters</p>
        <h2 className="product-features-title" style={{ fontSize: "24px", fontWeight: "bold" }} >CIP is not just AI-as-a-service. It’s the intelligence backbone for the next decade of digital transformation.</h2>
        <div className="product-features-grid">
          {productFeaturesData.map((feature, index) => (
            <div className="pfeature-item" key={index}>
              <FeatureIcon icon={feature.icon} />
              <h3 className="pfeature-title">{feature.title}</h3>
              <p className="pfeature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductFeatures; 